module.exports = __webpack_public_path__ + "4856752d07fe4f46e2d526b95c9fbf2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/realisations/saladexpress/saladexpress_02.jpg
// module id = 1oip
// module chunks = 0